/** Sentinel for the Favorites row inside a robot/asset dropdown. Not a real id. */
export const FAVORITES_DROPDOWN_VALUE = '__favorites__'

/** Keep the existing order inside each group and move pinned rows ahead of the rest. */
export function sortWithFavoritesFirst<T extends { id: number }>(
  items: readonly T[],
  favoriteIds: ReadonlySet<number>
): T[] {
  if (favoriteIds.size === 0 || items.length < 2) {
    return items as T[]
  }
  const favorites: T[] = []
  const rest: T[] = []
  for (const item of items) {
    if (favoriteIds.has(item.id)) {
      favorites.push(item)
    } else {
      rest.push(item)
    }
  }
  if (favorites.length === 0 || rest.length === 0) {
    return items as T[]
  }
  return favorites.concat(rest)
}

/** Keep a fleet scope inside the pinned ids. `undefined` means the whole fleet. */
export function narrowToFavoriteIds(scope: readonly number[] | undefined, favoriteIds: readonly number[]): number[] {
  const favorite = new Set(favoriteIds)
  const source = scope === undefined ? favoriteIds : scope
  const seen = new Set<number>()
  const result: number[] = []
  for (const id of source) {
    if (!favorite.has(id) || seen.has(id)) continue
    seen.add(id)
    result.push(id)
  }
  return result
}
